import axiosInstance from "./axios-instance";

const generateOutcomesReport = async (quarter, selectedFinancialYear) => {
  return await axiosInstance({
    url: "/app/report/outcomes",
    params: {quarter, selectedFinancialYear},
    method: "GET",
    responseType: "blob",
    timeout: 30000
  }).then((res) => res.data);
};


const generateNarrativeReport = async (data) => {
  return await axiosInstance({
    url: "/app/ai/outcomes-reporting/goal-data",
    method: "POST",
    data,
    timeout: 60000
  }).then((res) => res.data)
}


const generateElderReport = async (selectedFinancialYear) => {
  return await axiosInstance({
    url: "/app/report/te-kauae",
    params: {selectedFinancialYear},
    method: "GET",
    responseType: "blob",
    timeout: 30000
  }).then((res) => res.data);
};


const saveNarrativeReport = async (data) => {
  return await axiosInstance({
    url: "/app/narrative-report",
    method: "POST",
    data,
    timeout: 60000
  }).then((res) => res.data)
}


const previousNarrativeReport = async (clientId, count = null) => {
  const url = count ? `/app/narrative-report/client/${clientId}/${count}` : `/app/narrative-report/client/${clientId}`;
  console.log(url)
  return await axiosInstance({
    url: url,
    method: "GET",
    timeout: 60000,
    cache: false
  }).then((res) => res.data)
}


const generateTeAra = async (payload) => {
  return await axiosInstance({
    url: "/app/report/te-ara",
    params: payload,
    method: "GET",
    responseType: "blob",
    timeout: 180000
  }).then((res) => res.data);
}

const generateGambling = async (payload) => {
  return await axiosInstance({
    url: "/app/report/gambling",
    params: payload,
    method: "GET",
    responseType: "blob",
    timeout: 30000
  }).then((res) => res.data);
}

const generateTeTumuWaioraSupport = async (payload) => {
  return await axiosInstance({
    url: "/app/report/te-tumu-waiora-support",
    params: payload,
    method: "GET",
    responseType: "blob",
    timeout: 30000
  }).then((res) => res.data);
}

const generateKoTatouReport = async (quarter, selectedFinancialYear) => {
  return await axiosInstance({
    url: "/app/report/ko-tatou",
    params: { quarter, selectedFinancialYear },
    method: "GET",
    responseType: "blob",
    timeout: 30000
  }).then((res) => res.data);
}

const generateKoTatouCustomReport = async (startDate, endDate) => {
  return await axiosInstance({
    url: "/app/report/ko-tatou/custom",
    params: { start_date: startDate, end_date: endDate },
    method: "GET",
    responseType: "blob",
    timeout: 30000
  }).then((res) => res.data);
}


const generateTLReport = async (params) => {
  return await axiosInstance({
    url: "/app/report/tl/generate",
    method: "GET",
    params,
    responseType: "blob",
    timeout: 120000,
    cache: false
  }).then((res) => res.data)
}


export default {
  generateOutcomesReport,
  generateNarrativeReport,
  generateElderReport,
  saveNarrativeReport,
  previousNarrativeReport,
  generateTeAra,
  generateGambling,
  generateTeTumuWaioraSupport,
  generateKoTatouCustomReport,
  generateKoTatouReport,
  generateTLReport
}
